<template>
  <div
    class="differences"
    @click.stop="">
    <sweet-modal
      overlay-theme="dark"
      ref="modal"
      width="80%"
      :title="title || 'Changes'"
      @close="restoreBodyOverflow">
      <div
        class="diff-text"
        ref="diffText"
        v-html="differences">
      </div>
    </sweet-modal>
  </div>
</template>

<script>
import { describeDifferences } from 'shared-js/describe-diff'
import { SweetModal } from 'sweet-modal-vue'
import { EventBus, events } from '@/common/EventBus'
import { deepClone } from '@/common/utils/deep-clone'

function toObj (arr) {
  return { id: 'foo', obj: arr }
}

export default {
  components: { SweetModal },

  data () {
    return {
      base: {},
      override: {},
      title: ''
    }
  },

  mounted () {
    EventBus.$on(events.openDifferences, this.show)
  },

  computed: {
    useBase () {
      return Array.isArray(this.base) ? toObj(this.base) : this.base
    },

    useOverride () {
      return Array.isArray(this.override) ? toObj(this.override) : this.override
    },

    differences () {
      if (!this.useBase || !this.useOverride) {
        return ''
      }

      const ret = describeDifferences(deepClone(this.useBase), deepClone(this.useOverride))

      // console.log(ret)
      if (!ret) {
        return 'There are no changes.'
      }

      return ret
        .replace(/ \((object|number|bigint|string|boolean|undefined|symbol)\)/g, '') // remove value types
        .replace(/^(.+: {2})$/gm, '<b>$1</b>') // bold path lines
        .replace(/\n/g, '<br>') // newlines to BRs
        .replace(/ /g, '&nbsp;') // indenting
    }
  },

  methods: {
    show (params) {
      if (!params.title) {
        return
      }

      ['base', 'override', 'title'].forEach(val => {
        this.$set(this, val, params[val])
      })

      this.$refs.modal.open()

      this.$nextTick(() => { this.$refs.diffText.parentNode.parentNode.parentNode.scrollTo(0, 0) })
    },

    restoreBodyOverflow () {
      document.body.style.overflow = 'auto'
    }
  },

  beforeDestroy () {
    EventBus.$off(events.openDifferences, this.show)
  }
}
</script>

<style scoped>
  .differences { color: #333; }
  .diff-text { font-family: 'Courier New', Courier, monospace; }
</style>
